import { useEffect, useState } from 'react';
import { useCurrentCommandState } from '../../store/currentCommandStateStore';
import CanvasTooltip from './CanvasTooltip';

const MouseLabel = () => {
  const measureText = useCurrentCommandState(s => s.measureText);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handler = (e: MouseEvent) => setPos({ x: e.pageX, y: e.pageY });
    document.addEventListener('mousemove', handler);
    return () => document.removeEventListener('mousemove', handler);
  }, []);

  if (measureText === null) return null;

  return <CanvasTooltip x={pos.x} y={pos.y} text={measureText} />;
};

export default MouseLabel;
